/**
 * RAL Color mapping and texture lists for Prestige Configurator
 * Matches Vue app color service implementation
 */

// RAL color codes to hex mapping
export const RAL_COLOR_MAP: Record<string, string> = {
  bronze: "#796d68",
  "7006": "#766A5E",
  "7015": "#4F5358",
  "7016": "#383E42",
  "7035": "#C5C7C4",
  "9001": "#E9E0D2",
  "9002": "#D7D5CB",
  "9003": "#ECECE7",
  "9005": "#0E0E00",
  "9006": "#A1A1A0",
  "9016": "#F1F0EA",
  "9018": "#C8CBC4",
};

export type TextureOption = {
  img: string;
  name: string;
  hex: string;
};

// Frame texture options
export const FRAME_TEXTURES: TextureOption[] = [
  { img: "7015.png", name: "Graphite Gray", hex: "#4F5358" },
  { img: "7035.png", name: "Pebble Beach", hex: "#C5C7C4" },
  { img: "9016.png", name: "Dove White", hex: "#F1F0EA" },
  { img: "bronze.png", name: "Sierra Bronze", hex: "#796d68" },
  // { img: '9001.png', name: 'RAL 9001', hex: '#E9E0D2' },
  // { img: '7016.png', name: 'RAL 7016', hex: '#383E42' },
  // { img: '9005.png', name: 'RAL 9005', hex: '#0E0E00' },
  // { img: '7006.png', name: 'RAL 7006', hex: '#766A5E' },
  // { img: '9006.png', name: 'RAL 9006', hex: '#A1A1A0' },
];

// Louver/Blind texture options
export const BLIND_TEXTURES: TextureOption[] = [
  { img: "7015.png", name: "Graphite Gray", hex: "#4F5358" },
  { img: "7035.png", name: "Pebble Beach", hex: "#C5C7C4" },
  { img: "9016.png", name: "Dove White", hex: "#F1F0EA" },
  { img: "bronze.png", name: "Sierra Bronze", hex: "#796d68" },
  // { img: '9001.png', name: 'RAL 9001', hex: '#E9E0D2' },
  // { img: '7016.png', name: 'RAL 7016', hex: '#383E42' },
  // { img: '9005.png', name: 'RAL 9005', hex: '#0E0E00' },
  // { img: '7006.png', name: 'RAL 7006', hex: '#766A5E' },
  // { img: '9006.png', name: 'RAL 9006', hex: '#A1A1A0' },
];

// Curtain texture options for wind screens
export const CURTAIN_TEXTURES: TextureOption[] = [
  { img: "curtain_black.png", name: "Black", hex: "#1A1A1A" },
  { img: "curtain_texture.jpg", name: "Textured", hex: "#808080" },
];

// Solid Composite Privacy Wall texture options
export const WPC_WALL_TEXTURES: TextureOption[] = [
  { img: "wpc_sh.jpg", name: "Iron Timber", hex: "#4b4d4e" },
  { img: "wpc_ym.jpg", name: "Teak", hex: "#9a8070" },
];

// WPC Fencing/Slat texture options
export const WPC_TEXTURES: TextureOption[] = [
  { img: "wpc_ym.jpg", name: "Teak", hex: "#8B7355" },
  { img: "wpc_yuanmu.jpg", name: "Wood", hex: "#C4A77D" },
  { img: "wpc_qh.jpg", name: "Pebble Beach", hex: "#B0B0B0" },
  { img: "wpc_sh.jpg", name: "Dark Gray", hex: "#505050" },
];

// Deco screen texture options (Deco A, Deco Yuguwen, Deco Screen, Vertical Screen)
export const DECO_TEXTURES: TextureOption[] = [
  { img: "7015.png", name: "Graphite Gray", hex: "#4F5358" },
  { img: "7035.png", name: "Pebble Beach", hex: "#C5C7C4" },
  { img: "9016.png", name: "Dove White", hex: "#F1F0EA" },
];

// Accessory frame textures (matches Vue frameTextureList)
export const ACCESSORY_FRAME_TEXTURES: TextureOption[] = [
  { img: "7015.png", name: "Graphite Gray", hex: "#4F5358" },
  { img: "7035.png", name: "Pebble Beach", hex: "#C5C7C4" },
  { img: "9016.png", name: "Dove White", hex: "#F1F0EA" },
];

// Screen panel textures (Horizontal, Tilting Horizontal)
export const SCREEN_PANEL_TEXTURES: TextureOption[] = [
  { img: "7015.png", name: "Graphite Gray", hex: "#4F5358" },
  { img: "7035.png", name: "Pebble Beach", hex: "#C5C7C4" },
  { img: "9016.png", name: "Dove White", hex: "#F1F0EA" },
  { img: "tiltingHorizontalGrid.jpg", name: "Woodgrain", hex: "#D4C4A8" },
];

/**
 * Try to extract RAL color hex from texture filename
 */
export const tryRalColor = (img: string): string => {
  for (const [code, hex] of Object.entries(RAL_COLOR_MAP)) {
    if (img.includes(code)) return hex;
  }
  return "#CCCCCC"; // Default gray
};
